import GridData from 'components/GridData/index';

const GuestInformationCard = ({ leadGuestName, guestQffNumber, guestAbnNumber, guestPhoneNumber, guestEmailAddress }) => {
  const cells = [
    { label: 'Lead Guest', value: leadGuestName },
    { label: 'QFF Number', value: guestQffNumber },
    { label: 'ABN Number', value: guestAbnNumber },
    { label: 'Phone Number', value: guestPhoneNumber },
    { label: 'Email Address', value: guestEmailAddress },
  ].filter(({ value }) => value);

  return <GridData data={cells} />;
};

export default GuestInformationCard;
